import * as React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Button, Dialog, Stack, Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import useStore from "store/hook";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";

dayjs.extend(customParseFormat); // Enable custom format parsing

export default function TimePickerWithButtons({
  inspectionDetails,
  setInspectionDetails,
  setAddInspectionData,
  addInspectionData,
}) {
  const { store, setDialogue } = useStore();
  const { isOpen = false, action } = store?.app?.dialogs?.openTimePicker || {};

  // let initialTime =
  //   action === "arrival"
  //     ? Number(arrivalTime * 1000)
  //     : action === "left"
  //     ? Number(leftTime * 1000)
  //     : action === "inspectiontime"
  //     ? Number(inspectionCreateTime * 1000)
  //     : dayjs();

  let initialTime = React.useMemo(() => {
    const time =
      action === "arrival"
        ? Number(inspectionDetails?.arrivedTime * 1000)
        : action === "left"
        ? Number(inspectionDetails?.leftTime * 1000)
        : action === "inspectiontime"
        ? Number(inspectionDetails?.createdTime * 1000)
        : action == "addInsectiontime" && addInspectionData?.createdTime
        ? Number(addInspectionData?.createdTime * 1000)
        : action == "addarrival" && addInspectionData?.arrival_time
        ? Number(addInspectionData?.arrival_time * 1000)
        : action == "addleft" && addInspectionData?.left_time
        ? Number(addInspectionData?.left_time * 1000)
        : Date.now();

    return dayjs(time);
  }, [inspectionDetails, action]);

  const [tempTime, setTempTime] = React.useState(dayjs(initialTime));

  React.useEffect(() => {
    if (initialTime && isOpen) {
      setTempTime(dayjs(initialTime));
    }
  }, [initialTime]);

  const handleClose = () =>
    setDialogue({ type: "openTimePicker", isOpen: false });

  const handleConfirm = () => {
    const selectedTimeInMs = tempTime.valueOf();

    if (action == "arrival") {
      setInspectionDetails((prev) => ({
        ...prev,
        arrivedTime: Math.floor(selectedTimeInMs / 1000),
      }));
    } else if (action == "left") {
      setInspectionDetails((prev) => ({
        ...prev,
        leftTime: Math.floor(selectedTimeInMs / 1000),
      }));
    } else if (action == "inspectiontime") {
      setInspectionDetails((prev) => ({
        ...prev,
        createdTime: Math.floor(selectedTimeInMs / 1000),
      }));
    } else if (action == "addarrival") {
      setAddInspectionData((prev) => ({
        ...prev,
        arrival_time: Math.floor(selectedTimeInMs / 1000),
      }));
    } else if (action == "addleft") {
      setAddInspectionData((prev) => ({
        ...prev,
        left_time: Math.floor(selectedTimeInMs / 1000),
      }));
    } else if (action == "addInsectiontime") {
      setAddInspectionData((prev) => ({
        ...prev,
        createdTime: Math.floor(selectedTimeInMs / 1000),
      }));
    }

    handleClose();
    initialTime = dayjs();
    setTempTime(dayjs());
  
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog
        PaperProps={{
          sx: { overflowX: "hidden" },
        }}
        open={isOpen}
        onClose={handleClose}
      >
        <Typography variant="h6" sx={{ textAlign: "center", marginBottom: 1 }}>
          {action === "arrival"
            ? "Select Arrival Time"
            : action == "left"
            ? "Select Left Time"
            : "select Inspection Time"}
        </Typography>

        <StaticTimePicker
          value={tempTime}
          onChange={(newTime) => setTempTime(newTime)}
          onAccept={handleConfirm}
          onClose={handleClose}
          ampm
          slotProps={{
            actionBar: {
              actions: [],
            },
            layout: {
              sx: {
                "& .MuiTimePickerToolbar-root": {
                  padding: "10px",
                },
                "& .MuiTypography-root": {
                  fontSize: "20px",
                  fontWeight: "bold",
                  textAlign: "center",
                },
              },
            },
          }}
        />

        {/* Custom buttons to ensure handleAccept always fires */}
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={{ mt: 2 }}
        >
          <Button onClick={handleClose} sx={{ color: "#02255B" }}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} sx={{ color: "#02255B" }}>
            OK
          </Button>
        </Stack>
      </Dialog>
    </LocalizationProvider>
  );
}
